import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-carta-porte-create',
  template: '<div class="card"><div class="card-body">Redireccionando...</div></div>',
  styles: []
})
export class CartaPorteCreateComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.navigateByUrl('/carta-porte/add');
  }
}
